import { useParams as useReactRouterDOMParams } from 'react-router-dom';

import { AppNavigation } from '@lib/types';

import { UseParamsResult } from './types';

export const useParams = <
  K extends keyof AppNavigation,
>(): UseParamsResult<K> => {
  const params = useReactRouterDOMParams();

  return {
    params: params as AppNavigation[K],
  };
};
